export default "__VITE_PUBLIC_ASSET__7217e17a__"